// Sitenin tek merkezden yonetilen sabitleri.
// Bir link degisecekse sadece burayi duzenlemek yeterli.

export const SITE_URL = 'https://www.travelistanbulapp.com';
export const SITE_DOMAIN = 'www.travelistanbulapp.com';
export const CONTACT_EMAIL = 'travelistanbulapp@gmail.com';

export const STORE_LINKS = {
  googlePlay: 'https://play.google.com/store/apps/details?id=com.okaltech.travelistanbul',
  appStore: 'https://apps.apple.com/us/app/travel-istanbul-audio-guide/id6747380031',
};

// Instagram bio / paylasim linki. Acan cihaza gore (iOS / Android) dogru
// magazaya yonlendirir, taninmayan cihazda iki butonu birden gosterir.
// Sayfanin kendisi: public/indir.html  (yonlendirme kurallari: vercel.json)
export const SMART_LINK = `${SITE_URL}/indir`;
